var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}import { t } from "../../I18N";
import { switchOneUpEntity } from "../actions/actions";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon } from "../../UI";

import { selectIsPristine } from "../common";

const defaultProps = {
  isPristine: true,
  isLast: false,
  thesaurusName: '',
  switchOneUpEntity: (_delta, _save) => {}
};



export class OneUpEntityButtonsBase extends Component {


  renderNextButton(isPristine, btnClass) {
    return /*#__PURE__*/(
      _jsx("button", {
        type: "button",
        onClick: () => this.props.switchOneUpEntity(+1, true),
        className: `save-and-next ${!isPristine ? 'btn-success' : ''} ${btnClass}` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "save-and-next" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Save and go to next'))));


  }

  render() {
    const { isPristine } = this.props;
    const btnClass = isPristine ? 'btn btn-default btn-disabled' : 'btn btn-default';
    return /*#__PURE__*/(
      _jsx("div", { className: "content-footer" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: () => this.props.switchOneUpEntity(0, false),
        className: `cancel-edit-metadata ${!isPristine ? 'btn-danger' : ''} ${btnClass}` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "undo" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Discard changes'))), /*#__PURE__*/

      _jsx("button", {
        type: "button",
        onClick: () => this.props.switchOneUpEntity(0, true),
        className: `save-metadata ${btnClass}` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "save" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Save document'))),

      this.renderNextButton(isPristine, btnClass)));


  }
}_defineProperty(OneUpEntityButtonsBase, "defaultProps", defaultProps);

const mapStateToProps = (state) => ({
  isPristine: selectIsPristine(state)
});

export const OneUpEntityButtons = connect(mapStateToProps, { switchOneUpEntity })(
OneUpEntityButtonsBase);